import React from 'react';
import { useNavigate } from 'react-router-dom';

const VentanaEmergenteGeneral = ({ title, message, onClose, buttonText = "Entendido", route = null }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    onClose();
    if (route) {
      navigate(route);
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <button onClick={onClose} style={styles.close}>✖</button>
        <h2>{title}</h2>
        <p style={styles.text}>{message}</p>
        <button onClick={handleClick} style={styles.button}>{buttonText}</button>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.7)', display: 'flex',
    justifyContent: 'center', alignItems: 'center', zIndex: 9999
  },
  modal: {
    backgroundColor: '#fff', padding: '30px', borderRadius: '12px',
    maxWidth: '400px', textAlign: 'center', boxShadow: '0 0 10px rgba(0,0,0,0.3)',
    position: 'relative'
  },
  close: {
    position: 'absolute', top: '10px', right: '15px',
    background: 'none', border: 'none', fontSize: '18px', cursor: 'pointer'
  },
  text: {
    margin: '20px 0', lineHeight: '1.4'
  },
  button: {
    padding: '10px 20px', backgroundColor: '#0151a2',
    color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer'
  }
};

export default VentanaEmergenteGeneral;
